import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { SiteSettingsProvider } from "@/contexts/SiteSettingsContext";
import { Toaster } from "@/components/ui/sonner";
import AdminLayout from "@/components/layout/AdminLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AboutMe from "@/pages/AboutMe";
import PersonalInformation from "@/pages/PersonalInformation";
import Education from "@/pages/Education";
import Experience from "@/pages/Experience";
import TechnicalSkills from "@/pages/TechnicalSkills";
import Expertise from "@/pages/Expertise";
import Achievements from "@/pages/Achievements";
import Testimonials from "@/pages/Testimonials";
import Blogs from "@/pages/Blogs";
import Interests from "@/pages/Interests";
import SocialLinks from "@/pages/SocialLinks";
import SiteSettings from "@/pages/SiteSettings";
import Certifications from "@/pages/Certifications";
import Leadership from "@/pages/Leadership";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SiteSettingsProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="about" element={<AboutMe />} />
              <Route path="personal" element={<PersonalInformation />} />
              <Route path="education" element={<Education />} />
              <Route path="experience" element={<Experience />} />
              <Route path="skills" element={<TechnicalSkills />} />
              <Route path="expertise" element={<Expertise />} />
              <Route path="achievements" element={<Achievements />} />
              <Route path="certifications" element={<Certifications />} />
              <Route path="leadership" element={<Leadership />} />
              <Route path="testimonials" element={<Testimonials />} />
              <Route path="blogs" element={<Blogs />} />
              <Route path="interests" element={<Interests />} />
              <Route path="social" element={<SocialLinks />} />
              <Route path="settings" element={<SiteSettings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </BrowserRouter>
          <Toaster richColors position="bottom-right" />
        </SiteSettingsProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
